import type { Reference, Resource } from '@medplum/fhirtypes'
import type { ExtendedResource } from '@seen/core/ExtendedResource'
import { generateMedplumAppLink } from '@seen/core/utilsExtendedResource'
import { IconExternalLink } from '@tabler/icons-react'
import type { ReactNode } from 'react'
import { DropdownMenuItem } from '#src/components/core/dropdown-menu/DropdownMenuItem.tsx'
import { useShowMedplumLink } from '#src/hooks/useShowMedplumLink.ts'

export interface DropdownMenuMedplumLinkItemProps {
  to: Resource | Reference | ExtendedResource<any>
  pathSuffix?: string
  label?: string
}

export function DropdownMenuMedplumLinkItem({
  to,
  pathSuffix,
  label = 'Open in Medplum',
}: DropdownMenuMedplumLinkItemProps): ReactNode {
  const showMedplumLink = useShowMedplumLink()
  if (!showMedplumLink) {
    return null
  }

  const url = generateMedplumAppLink(to, pathSuffix)

  return (
    <DropdownMenuItem asChild>
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-2"
      >
        <IconExternalLink className="-mt-px size-4 text-foreground-secondary" />
        {label}
      </a>
    </DropdownMenuItem>
  )
}
